/**
 * Standardize attribute value to be displayed as link (i18n)
 * For instance Stephen King -> stephen-king-12312
 *
 * @param label<string>
 * @param postfix<string>
 * @return {string}
 */
export const labelToUri = (label, postfix = null) => {
    if (postfix) {
        postfix = `-${postfix}`;
    }

    return `${label
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9\s-]/g, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')}${postfix}`;
}

/**
 * Retrieve attribute value from url
 * For instance stephen-king-12312 -> 12312
 *
 * @return {number}
 * @param input<string>
 */
export const retrieveAttributeValue = (input) => {
    const match = input.match(/\d+$/);

    return match ? match[0] : 0;
};

/**
 * Isolate value from customFilters to prevent join values
 *
 * @param attribute_code<string>
 * @param attribute_value<string>
 * @return {string}
 */
export const isolatedAttrValLink = ({attribute_code, attribute_value }) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const customFilters = params.get('customFilters') || '';
    const filterRegex = new RegExp(`(${attribute_code}):([^;]*)`);
    const newFilter = `${attribute_code}:${attribute_value}`;

    if (filterRegex.test(customFilters)) {
        params.set('customFilters', customFilters.replace(filterRegex, newFilter));
    } else {
        params.set('customFilters', customFilters ? `${customFilters};${newFilter}` : newFilter);
    }

    return `${url.pathname}?${params.toString()}`;
}
